<template>
  <v-list-item :href="link"
               :class="{'link':!!link}"
               :target="target"
               :data-testid="value || text"
               :disabled="!!disabled"
               v-on="$listeners">

    <v-list-item-icon v-if="icon">
      <v-icon size="16">{{icon}}</v-icon>
      <span data-testid="dotBadges"
            :class="`icon-badge ${active}`"
            v-if="!disabled && active"></span>
    </v-list-item-icon>

    <v-list-item-content>
      {{text}}
    </v-list-item-content>

  </v-list-item>
</template>

<script>
export default {
  name: 'VcitaMultiLevelMenuItem',
  props: {
    text: {
      type: String,
      required: true
    },
    icon: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    active: {
      type: String,
      validator(active) {
        return ['active','inactive'].indexOf(active) > -1
      }
    },
    link: {
      type: String
    },
    value: {
      type: String
    }
  },
  computed: {
    target() { // undefined so it won't throw error in case link is not provided
      return !!this.link ? '_parent' : undefined
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";

.v-list-item {
  padding: 12px 16px;
  min-height: unset;

  .v-list-item__icon {
    position: relative;
    margin: unset;
    margin-inline-end: 12px;
    height: fit-content;
    align-self: unset;

    .v-icon {
      color: $black_color-2;
    }
  }

  &--disabled .v-list-item__icon {
    .v-icon {
      color: $grey-color-17;
    }
  }

  .icon-badge {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    position: absolute;
    bottom: -4px;
    right: 1px;

    &.active {
      background-color: $green-color-2;
      border: 2px solid $white-color-1;
    }

    &.inactive {
      width: 10px;
      height: 10px;
      right: 2px;
      outline: 2px solid $white-color-1;
      background-color: $white-color-1;
      border: 2px solid $grey-color-17;
    }
  }

  &__content {
    font-size: 13px;
    color: $black_color-2;
    padding: 0;

    .v-list-item--disabled & {
      color: $grey-color-17;
    }
  }

  &.link {
    .v-icon, .v-list-item__content { // override vuetify important
      color: $blue-color-4;
    }
  }
}
</style>
